"use strict";
/**
 * Inventory Report Types
 *
 * Domain types for periodic inventory reports (monthly, quarterly, annual).
 * These reports aggregate stock flow data, detect anomalies, and compare periods.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPORT_LINE_CLASSIFICATION_LABELS = exports.SHRINKAGE_FLAG_LABELS = exports.ShrinkageFlag = exports.REPORT_PERIOD_TYPE_LABELS = exports.ReportPeriodType = void 0;
// ============================================================================
// Enums
// ============================================================================
/**
 * Report period type
 */
var ReportPeriodType;
(function (ReportPeriodType) {
    ReportPeriodType["monthly"] = "monthly";
    ReportPeriodType["quarterly"] = "quarterly";
    ReportPeriodType["annual"] = "annual";
})(ReportPeriodType || (exports.ReportPeriodType = ReportPeriodType = {}));
exports.REPORT_PERIOD_TYPE_LABELS = {
    [ReportPeriodType.monthly]: 'Mensual',
    [ReportPeriodType.quarterly]: 'Trimestral',
    [ReportPeriodType.annual]: 'Anual',
};
/**
 * Shrinkage flag — classifies the nature of each product's shrinkage
 */
var ShrinkageFlag;
(function (ShrinkageFlag) {
    /** Real unexplained loss */
    ShrinkageFlag["realLoss"] = "real_loss";
    /** Likely caused by conversion factor mismatch */
    ShrinkageFlag["conversionArtifact"] = "conversion_artifact";
    /** Expected consumption (internalUse items) */
    ShrinkageFlag["expectedConsumption"] = "expected_consumption";
    /** Surplus — more stock than expected */
    ShrinkageFlag["surplus"] = "surplus";
    /** Negligible (within tolerance) */
    ShrinkageFlag["negligible"] = "negligible";
})(ShrinkageFlag || (exports.ShrinkageFlag = ShrinkageFlag = {}));
exports.SHRINKAGE_FLAG_LABELS = {
    [ShrinkageFlag.realLoss]: 'Pérdida real',
    [ShrinkageFlag.conversionArtifact]: 'Posible error de conversión',
    [ShrinkageFlag.expectedConsumption]: 'Consumo esperado',
    [ShrinkageFlag.surplus]: 'Sobrante',
    [ShrinkageFlag.negligible]: 'Despreciable',
};
exports.REPORT_LINE_CLASSIFICATION_LABELS = {
    consumption: 'Consumo interno',
    expired: 'Caducidad',
    confirmed_loss: 'Pérdida confirmada',
    unconfirmed_loss: 'Sin confirmar',
    surplus: 'Sobrante',
    negligible: 'Despreciable',
};
